import React, { forwardRef } from 'react';
import { StyleSheet, TextInput as RNTextInput } from 'react-native';
import useMacFontScale from '@/hooks/useMacFontScale';
import { scaleTextStyle } from '@/constants/macFontScale';

// Keep the native input mounted when Appearance changes so drafts, selection,
// focus and the native multiline sizing behavior survive the new font size.
export default forwardRef(function TextInput({ style, ...props }, ref) {
  const scale = useMacFontScale();
  return <RNTextInput ref={ref} {...props}
    style={scale === 1 ? style : scaleTextStyle(StyleSheet.flatten(style), scale)} />;
});
